/**
 * ID:N GENERERAS PÅ KLIENTEN. Kontot, firman, tidraden, filen, op_id:t — allt
 * utom serverns egna rader får sitt id här (worker/src/util/ids.ts säger det
 * ordagrant: "servern tilldelar ALDRIG ett id till något användaren skapat").
 * Det är vad som gör offline möjligt i steg 5: en rad kan skapas, refereras och
 * läggas i utkorgen utan att nätet varit inblandat.
 *
 * FORMEN ÄR INTE FRI. Båda op-loggarnas CHECK i schema/d1.sql och
 * schema/company.sql säger length BETWEEN 20 AND 40, och
 * worker/src/util/ids.ts kräver dessutom /^[A-Za-z0-9_-]+$/. En ULID på 26
 * tecken Crockford-base32 ligger inom båda och är dessutom SORTERBAR i
 * tidsordning — två rader som skapades samma millisekund hamnar ändå i den
 * ordning de skapades.
 *
 * ALGORITMEN ÄR AVSIKTLIGT IDENTISK med worker/src/util/ids.ts. Skulle
 * klienten och servern producera olika form vore det serverns validering som
 * föll, med ett anonymt VALIDATION_FAILED långt från orsaken.
 */

import { ID_MAX_LENGTH, ID_MIN_LENGTH } from './konstanter';

const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

/** 10 tecken tid + 16 tecken slump = 26 tecken. */
export const nyUlid = (nu: number = Date.now()): string => {
  let tid = nu;
  const tidstecken: string[] = [];
  for (let i = 0; i < 10; i += 1) {
    tidstecken.unshift(CROCKFORD[tid % 32] ?? '0');
    tid = Math.floor(tid / 32);
  }
  const slump = new Uint8Array(16);
  crypto.getRandomValues(slump);
  let svans = '';
  for (const byte of slump) svans += CROCKFORD[byte % 32] ?? '0';
  return tidstecken.join('') + svans;
};

/**
 * Samma prov som worker/src/util/ids.ts isWellFormedId. Finns här för att en
 * skärm ska kunna avvisa ett trasigt id INNAN det blir ett nätanrop.
 */
export const arValformatId = (varde: unknown): varde is string =>
  typeof varde === 'string' &&
  varde.length >= ID_MIN_LENGTH &&
  varde.length <= ID_MAX_LENGTH &&
  /^[A-Za-z0-9_-]+$/.test(varde);
